<template>
  <div>
    <b-card class="mt-4" title="Nowy użytkownik">
      <form name="form" @submit.prevent="handleRegister">
        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label"
            >Nazwa użytkownika</label
          >
          <input
            type="text"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            v-model="userName"
          />
          <div
            class="alert alert-danger"
            role="alert"
            v-if="fromErrors.isUserNameExist"
          >
            Podana nazwa użytkownika jest już w bazie danych
          </div>
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Hasło</label>
          <input
            type="password"
            class="form-control"
            id="password"
            v-model="form.password"
          />
        </div>
        <div class="mb-3">
          <label for="role" class="form-label">Uprawnienie</label>
          <v-select
            label="name"
            :options="roles"
            v-model="form.role"
          ></v-select>
        </div>
        <div class="div-form-buttons-area">
          <button type="submit" class="btn btn-primary" :disabled="!isValid">
            Stwórz konto
          </button>
          <button type="button" class="btn-warning btn" @click="clearForm">
            Wyczyść formularz
          </button>
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import axios from "axios";
import User from "../../../models/User";

export default {
  watch: {
    userName(value) {
      this.form.name = value;
      this.validateUserName(value);
    },
  },
  components: {},
  mixins: [urlConfig, toastr],
  mounted() {
    this.$store.dispatch("getUserFormData");
  },
  computed: {
    roles() {
      return this.$store.state.userFormData.roles;
    },
    isValid() {
      if (
        this.form.name.length > 0 &&
        this.form.password.length > 0 &&
        this.form.role
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      userName: "",
      fromErrors: {
        isUserNameExist: false,
      },
      form: {
        name: "",
        password: "",
        role: 0,
      },
    };
  },
  methods: {
    clearForm() {
      this.userName = "";
      this.form.name = "";
      this.form.password = "";
      this.form.role = 0;
    },
    validateUserName(name) {
      if (name.length > 0) {
        var that = this;
        var url = this.url.serverUrl + this.url.Auth.IsUserNameExist + name;
        axios
          .get(url)
          .then(function (res) {
            that.fromErrors.isUserNameExist = res.data;
          })
          .catch(function (e) {
            console.log(e);
          });
      }
    },
    handleRegister() {
      this.message = "";
      var that = this;
      var newUser = new User(
        this.form.name,
        this.form.password,
        this.form.role.id
      );
      this.$store.dispatch("register", newUser).then(
        (data) => {
          this.message = data.message;
          that.DisplaySuccess(
            "Sukces!",
            "Konto dla użytkownika " + that.form.name + " zostało utworzone"
          );
          that.clearForm();
        },
        (error) => {
          this.message =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
  },
};
</script>